import { useState, useCallback } from 'react';
import { Layout, Tabs, Card, Space } from 'antd';
import { 
  FolderOutlined, 
  CloudUploadOutlined,
} from '@ant-design/icons';
import StorageStats from '../components/StorageStats';
import FileUpload from '../components/FileUpload';
import FileList from '../components/FileList';

const { Content } = Layout;

// 黑白灰商务配色方案
const COLORS = {
  primary: '#000000',      // 黑色 - 主色调
  secondary: '#333333',    // 深灰
  success: '#10B981',      // 绿色（保持一点色彩用于成功状态）
  background: '#F5F5F5',   // 浅灰背景
  surface: '#FFFFFF',      // 白色 - 卡片背景
  text: '#000000',         // 黑色文字
  textMuted: '#666666',    // 中灰 - 次要文字
  border: '#E5E5E5',       // 浅灰 - 边框
  hover: '#F0F0F0',        // 悬停背景
};

export default function Home() {
  const [refreshKey, setRefreshKey] = useState(0);
  const [activeTab, setActiveTab] = useState('files');

  const handleRefresh = useCallback(() => {
    setRefreshKey((prev) => prev + 1);
  }, []);

  const handleAllUploadsComplete = useCallback((allSucceeded: boolean) => {
    handleRefresh();
    // 只有所有文件都成功上传时才切换到文件列表
    if (allSucceeded) {
      setActiveTab('files');
    }
  }, [handleRefresh]);

  const tabItems = [
    {
      key: 'files',
      label: (
        <Space size={8}>
          <FolderOutlined style={{ fontSize: 16 }} />
          <span>文件管理</span>
        </Space>
      ),
      children: <FileList key={refreshKey} onRefresh={handleRefresh} colors={COLORS} />,
    },
    {
      key: 'upload',
      label: (
        <Space size={8}>
          <CloudUploadOutlined style={{ fontSize: 16 }} />
          <span>上传文件</span>
        </Space>
      ),
      children: <FileUpload onAllUploadsComplete={handleAllUploadsComplete} colors={COLORS} />,
    },
  ];

  return (
    <Layout style={{ minHeight: '100vh', background: COLORS.background }}>
      <Content 
        style={{ 
          padding: '32px 24px',
          maxWidth: 1200,
          width: 1200,
          margin: '0 auto',
          boxSizing: 'border-box',
        }}
      >
        {/* Storage Stats Card */}
        <Card
          style={{ 
            marginBottom: 24, 
            borderRadius: 8,
            border: `1px solid ${COLORS.border}`,
            boxShadow: 'none',
            background: COLORS.surface,
          }}
          bodyStyle={{ padding: 0 }}
        >
          <StorageStats key={refreshKey} colors={COLORS} />
        </Card>

        {/* Main Content Tabs */}
        <Card
          style={{ 
            borderRadius: 8,
            border: `1px solid ${COLORS.border}`,
            boxShadow: 'none',
            background: COLORS.surface,
            minHeight: 500,
          }}
          bodyStyle={{ padding: '24px' }}
        >
          <Tabs
            activeKey={activeTab}
            onChange={setActiveTab}
            items={tabItems}
          />
        </Card>
      </Content>
    </Layout>
  );
}
